import { render } from "./KeywordSelector.vue?vue&type=template&id=9f4728da&scoped=true"
import script from "./KeywordSelector.vue?vue&type=script&lang=js"
export * from "./KeywordSelector.vue?vue&type=script&lang=js"

import "./KeywordSelector.vue?vue&type=style&index=0&id=9f4728da&lang=css"
import "./KeywordSelector.vue?vue&type=style&index=1&id=9f4728da&scoped=true&lang=css"

import exportComponent from "C:\\Users\\brettp\\Documents\\Workspaces\\dealer-portal\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9f4728da"]])

export default __exports__